import { logReportDownload } from '../../util/auditLogger';
import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";

import { FiFileText } from "react-icons/fi";
import Context from "../../Context";

import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import constant, { statuses } from "../../constants";
import * as xlsx from "xlsx";
import { thaiDate } from "../../util";
import { DatePicker } from "antd";
import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const ReportOrder = () => {
  const { callApi, configs } = Context();
  const [allOrders, setAllOrders] = useState([]);
  const [displayedOrders, setDisplayedOrders] = useState([]);
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
  const [selectedStatus, setSelectedStatus] = useState(false);
  const [selectDate, setSelectedDate] = useState();
  const [reportType, setReportType] = useState("roundDate");
  const [selectedPaymentChannel, setSelectedPaymentChannel] = useState(false);
  const [selectedDeliverChannel, setSelectedDeliverChannel] = useState(false);
  const [paidCurrency, setPaidCurrency] = useState(false);
  const [loading, setLoading] = useState(false);
  const [daily, setDaily] = useState(false);
  const [selectedUsePromoCode, setSelectedUsePromoCode] = useState("");

  const getOrderPrice = (order) => {
    if (order?.status === statuses.CANCEL) {
      return 0;
    }
    if (
      (paidCurrency === "LAK" || order?.paidCurrency === "LAK") &&
      order?.totalPrice_lak
    ) {
      return Number(order.totalPrice_lak) || 0;
    }
    return Number(order?.totalPrice) || 0;
  };

  const getOrders = async () => {
    setDisplayedOrders([]);
    setLoading(true);
    const queries = [];

    if (selectedStatus) {
      queries.push(["status", selectedStatus]);
    }
    if (selectedPaymentChannel) {
      queries.push(["paymentChannel", selectedPaymentChannel]);
    }

    if (reportType === "date") {
      queries.push(["createdAtDate", selectDate]);
    }

    if (selectedDeliverChannel) {
      queries.push(["deliverChannel", selectedDeliverChannel]);
    }

    if (selectedUsePromoCode === "true") {
      queries.push(["isUsePromoCode", "==", true]);
    } else if (selectedUsePromoCode === "false") {
      queries.push(["isUsePromoCode", "==", false]);
    }

    const allUserData = [];
    let keepGoing = true;
    let currentIndex = 0;
    let startAtId = "";
    let limit = 1000; // Reduced chunk size for faster initial load

    while (keepGoing) {
      console.log(`calling index ${currentIndex}-${currentIndex + limit}`);
      const data = await callApi(
        "orders-getAll",
        {
          queries,
          limit,
          startAfter: startAtId,
          roundDate: selectedRoundDate,
          orderBy: selectedStatus === statuses.APPROVE ? ["approvedAt", "asc"] : ["createdAt", "asc"],
        },
        { notShowLoading: true },
      );

      if (data.length < limit || !data.length || !data) {
        console.log("stop");
        keepGoing = false;
      } else {
        console.log(`fetching size: ${data.length}`);
        console.log("id", data[data.length - 1].id);
        startAtId = data[data.length - 1].id;
      }

      allUserData.push(...data);
      console.log(`allUserData size: ${allUserData.length}`);
      currentIndex += limit;
    }

    setLoading(false);

    // Filter data
    const filteredData =
      paidCurrency === "THB"
        ? allUserData.filter(
          (order) => !order.paidCurrency || order.paidCurrency !== "LAK",
        )
        : paidCurrency === "LAK"
          ? allUserData.filter((order) => order.paidCurrency === "LAK")
          : allUserData;

    // Calculate daily stats
    const daily = filteredData.reduce((acc, order) => {
      const orderPrice = getOrderPrice(order);
      if (typeof order.totalPrice === "string") {
        console.log(order);
      }
      if (acc[order.approvedAtDate || order.createdAtDate]) {
        if (order.paymentChannel === "qr" || order.paymentChannel === "bank") {
          acc[order.approvedAtDate || order.createdAtDate][
            order.paymentChannel
          ].lotto += order.size;
          acc[order.approvedAtDate || order.createdAtDate][
            order.paymentChannel
          ].count += 1;
          acc[order.approvedAtDate || order.createdAtDate][
            order.paymentChannel
          ].income += orderPrice;
        } else {
          acc[order.approvedAtDate || order.createdAtDate].noCount.lotto +=
            order.size;
          acc[order.approvedAtDate || order.createdAtDate].noCount.count += 1;
          acc[order.approvedAtDate || order.createdAtDate].noCount.income +=
            orderPrice;
        }
      } else {
        acc[order.approvedAtDate || order.createdAtDate] = {
          qr: {
            lotto: order.paymentChannel === "qr" ? order.size : 0,
            count: order.paymentChannel === "qr" ? 1 : 0,
            income:
              order.paymentChannel === "qr" ? orderPrice : 0,
          },
          bank: {
            lotto: order.paymentChannel === "bank" ? order.size : 0,
            count: order.paymentChannel === "bank" ? 1 : 0,
            income:
              order.paymentChannel === "bank" ? orderPrice : 0,
          },
          noCount: {
            lotto:
              order.paymentChannel !== "qr" && order.paymentChannel !== "bank"
                ? order.size
                : 0,
            count:
              order.paymentChannel !== "qr" && order.paymentChannel !== "bank"
                ? 1
                : 0,
            income:
              order.paymentChannel !== "qr" && order.paymentChannel !== "bank"
                ? orderPrice
                : 0,
          },
        };
      }

      return acc;
    }, {});

    console.log("🚀 ~ getOrders ~ daily:", daily);

    // Store all orders but only display first chunk
    setAllOrders(filteredData);
    setDisplayedOrders(filteredData.slice(0, 100)); // Show first 100
    setDaily(daily);
  };

  const handleDownload = async () => {
    const approvedOrder = allOrders;

    const {
      qrLotto,
      qrCount,
      qrIncome,
      bankLotto,
      bankCount,
      bankIncome,
      noCountLotto,
      noCount,
      noCountIncome,
    } = approvedOrder.reduce(
      (acc, order) => {
        const orderPrice = getOrderPrice(order);
        if (order.paymentChannel === "qr") {
          acc.qrCount++;
          acc.qrLotto += order.size;
          acc.qrIncome += orderPrice;
        } else if (order.paymentChannel === "bank") {
          acc.bankCount++;
          acc.bankLotto += order.size;
          acc.bankIncome += orderPrice;
        } else {
          acc.noCount++;
          acc.noCountLotto += order.size;
          acc.noCountIncome += orderPrice;
        }

        return acc;
      },
      {
        qrLotto: 0,
        qrCount: 0,
        qrIncome: 0,
        bankLotto: 0,
        bankCount: 0,
        bankIncome: 0,
        noCountLotto: 0,
        noCount: 0,
        noCountIncome: 0,
      },
    );
    const csvData = [
      [
        `รายงานคำสั่งซื้อสลาก_งวด_${selectedRoundDate}_ออก_ณ_วันที่${thaiDate()}`,
      ],

      [""],

      ["จำนวนคำสั่งซื้อที่ชำระด้วย qr", "สลากที่ชำระด้วย qr ", "รายได้จาก qr"],
      [qrCount, qrLotto, qrIncome],
      [
        "จำนวนคำสั่งซื้อที่ชำระด้วย bank",
        "สลากที่ชำระด้วย bank ",
        "รายได้จาก bank",
      ],
      [bankCount, bankLotto, bankIncome],
      [
        "จำนวนคำสั่งซื้อที่ไม่คิดเงิน",
        "สลากที่ไม่คิดเงิน ",
        "รายได้ที่ไม่ได้นำมาคำนวน",
      ],
      [noCount, noCountLotto, noCountIncome],
      ["รวม", "", "", qrIncome + bankIncome],
      [""],
      [
        "วันที่",
        "จำนวนคำสั่งซื้อ qr ",
        "จำนวนคำสั่งซื้อ bank ",
        "จำนวนคำสั่งซื้อ - ",
        "จำนวนสลาก qr ",
        "จำนวนสลาก bank ",
        "จำนวนสลาก - ",
        "รายได้ qr ",
        "รายได้ bank ",
        "รวม",
      ],
    ];

    Object.entries(daily).forEach(([key, value]) => {
      csvData.push([
        key,
        value.qr.count,
        value.bank.count,
        value.noCount.count,
        value.qr.lotto,
        value.bank.lotto,
        value.noCount.lotto,
        value.qr.income,
        value.bank.income,
        value.qr.income + value.bank.income,
      ]);
    });

    const isLakReport = paidCurrency === "LAK";

    if (isLakReport) {
      csvData.push([], [
        "ลำดับ",
        "เวลาสร้างคำสั่งซื้อ",
        "เวลาอนุมัติคำสั่งซื้อ",
        "รหัสคำสั่งซื้อ",
        "ช่องทางการสั่งซื้อ",
        "รหัสผู้ใช้",
        "ชื่อ-นามสกุล",
        "เบอร์โทรศัพท์",
        "จำนวนสลาก",
        "ส่วนลด",
        "ราคารวม (กีบ)",
        "ช่องทางการชำระ",
        "สลิป",
        "สถานะ",
      ]);

      allOrders.forEach((order, index) => {
        const isCancel = order.status === statuses.CANCEL;
        const orderPrice = isCancel ? "-" : getOrderPrice(order);
        csvData.push([
          index + 1,
          new Date(order.createdAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
          }),
          new Date(order.approvedAt).toLocaleTimeString("th-TH", {
            hour: "numeric",
            minute: "numeric",
          }),
          order.shortId,
          order.deliverChannel === "online"
            ? "1. ฝากไว้กับวันดี"
            : order.deliverChannel === "mail"
              ? "2. ส่งไปรษณีย์"
              : "3. มารับเอง 80 บาท",
          order.userId,
          order.firstName + " " + order.lastName,
          order.phone,
          order.size,
          `${order.coupon?.coupon?.name || ''} ${order.coupon.shortId || ''}`
          + (order.isUsePromoCode ? `${order.promoCode} (${order.promoDiscount})` : ""),
          orderPrice,
          order.paymentChannel || "-",
          order.slips || "-",
          order.status,
        ]);
      });
    } else {
      csvData.push([], [
        "ลำดับ",
        "เลขที่ใบกำกับภาษี",
        "เวลาสร้างคำสั่งซื้อ",
        "เวลาอนุมัติคำสั่งซื้อ",
        "รหัสคำสั่งซื้อ",
        "ช่องทางการสั่งซื้อ",
        "รหัสผู้ใช้",
        "ชื่อ-นามสกุล",
        "เบอร์โทรศัพท์",
        "จำนวนสลาก",
        "ส่วนลด",
        "ค่าสลาก",
        "ค่าบริการ",
        "ราคาก่อนภาษี",
        "ภาษี 7%",
        "ราคารวม",
        "ช่องทางการชำระ",
        "สถานะ",
      ]);

      allOrders.forEach((order, index) => {
        const isCancel = order.status === statuses.CANCEL;
        const orderPrice = isCancel ? "-" : getOrderPrice(order);
        const lottoPrice = isCancel ? "-" : (order.totalPrice > 0 ? order.size * 80 : 0);
        const serviceFee = isCancel ? "-" : (order.totalPrice > 0 ? order.totalPrice - order.size * 80 : 0);
        const priceBeforeVat = isCancel ? "-" : (Math.max(0, order.totalPrice - order.size * 80) * (100 / 107)).toFixed(2).toLocaleString();
        const vat7 = isCancel ? "-" : Math.max(0, order.totalPrice - order.size * 80 - (order.totalPrice - order.size * 80) * (100 / 107)).toFixed(2).toLocaleString();

        csvData.push([
          index + 1,
          // order.taxNo || "-",
          new Date(order.createdAt).toLocaleDateString("th-TH", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
          }),
          new Date(order.approvedAt).toLocaleTimeString("th-TH", {
            hour: "numeric",
            minute: "numeric",
          }),
          order.shortId,
          order.deliverChannel === "online"
            ? "1. ฝากไว้กับวันดี"
            : order.deliverChannel === "mail"
              ? "2. ส่งไปรษณีย์"
              : "3. มารับเอง 80 บาท",
          order.userId,
          order.firstName + " " + order.lastName,
          order.phone,
          order.size,
          `${order.coupon?.coupon?.name || ''} ${order.coupon.shortId || ''}`
          + (order.isUsePromoCode ? `${order.promoCode} (${order.promoDiscount})` : ""),
          lottoPrice,
          serviceFee,
          priceBeforeVat,
          vat7,
          orderPrice,
          order.paymentChannel || "-",
          order.status,
        ]);
      });
    }

    const ws = xlsx.utils.aoa_to_sheet(csvData);
    const wb = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
    logReportDownload();
    xlsx.writeFile(
      wb,
      `รายงานคำสั่งซื้อสลาก_งวด_${selectedRoundDate}_ออก_ณ_วันที่${thaiDate()}.xlsx`,
    );
  };

  // Load more data when user scrolls near bottom
  const handleLoadMore = () => {
    if (displayedOrders.length < allOrders.length) {
      const newLimit = Math.min(displayedOrders.length + 100, allOrders.length);
      setDisplayedOrders(allOrders.slice(0, newLimit));
    }
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mb-24">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานคำสั่งซื้อสลาก"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold ">ค้นหาคำสั่งซื้อสลาก</p>
        </div>
        <div className="relative grid grid-cols-2 items-center gap-3 p-3 ">
          {loading && (
            <div className="z-50 bg-[rgb(255,255,255,0.7)] absolute h-full w-full flex justify-center items-center">
              <Spinner className="w-4 h-4 " />
            </div>
          )}
          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">งวด</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedRoundDate}
                onChange={(e) => setSelectedRoundDate(e.target.value)}
              >
                {configs.roundDates.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="gap-2">
            <p className="font-medium text-xs">รูปแบบรายงาน</p>
            <div>
              <select
                className="border-1 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={reportType}
                onChange={(e) => {
                  setReportType(e.target.value);
                }}
              >
                <option value={"roundDate"}>ทั้งงวด</option>
                <option value={"date"}>รายวัน </option>
              </select>
            </div>
          </div>
          <div>
            <p className="font-medium text-xs">สถานะ</p>
            <div className="flex">
              <DatePicker
                className="border-1 w-full border-gray-300 h-9 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:cursor-not-allowed"
                locale={buddhistLocale}
                disabled={reportType === "roundDate"}
                value={selectDate ? dayjs(selectDate, "YYYY-MM-DD") : false}
                onChange={(en, th) => {
                  const selectedDate =
                    th.split("-")[2] -
                    543 +
                    "-" +
                    th.split("-")[1] +
                    "-" +
                    th.split("-")[0];

                  setSelectedDate(selectedDate);
                }}
              />
            </div>
          </div>
          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">สถานะ</p>
            <div>
              <select
                className="border-1 w-full border-gray-300 h-9 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedStatus}
                onChange={(e) => {
                  console.log(e.target.value);
                  setSelectedStatus(e.target.value);
                }}
              >
                <option value={""}>ทั้งหมด</option>
                <option value={statuses.APPROVE}>อนุมัติ </option>
                <option value={statuses.PAID}>จ่ายแล้ว</option>
                <option value={statuses.PENDING}>รอจ่าย</option>
                <option value={statuses.CANCEL}>ยกเลิก</option>
              </select>
            </div>
          </div>
          <div className="gap-2">
            <p className="font-medium text-xs">รูปแบบการชำระ</p>
            <div>
              <select
                className="border-1 w-full border-gray-300 h-9 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedPaymentChannel}
                onChange={(e) => setSelectedPaymentChannel(e.target.value)}
              >
                <option value={""}>ทั้งหมด</option>
                <option value={"qr"}>QR </option>
                <option value={"bank"}>แนบสลิป</option>
              </select>
            </div>
          </div>
          <div className="gap-2">
            <p className="font-medium text-xs">รูปแบบการจัดส่ง</p>
            <div>
              <select
                className="border-1 w-full border-gray-300 h-9 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedDeliverChannel}
                onChange={(e) => setSelectedDeliverChannel(e.target.value)}
              >
                <option value={""}>ทั้งหมด</option>
                <option value={"online"}>1. ฝากไว้กับวันดี </option>
                <option value={"mail"}>2. ส่งไปรษณีย์</option>
                <option value={"offline"}>3. มารับเอง 80 บาท</option>
              </select>
            </div>
          </div>
          <div className="gap-2">
            <p className="font-medium text-xs">ค่าเงิน</p>
            <div>
              <select
                className="border-1 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={paidCurrency}
                onChange={(e) => {
                  setPaidCurrency(e.target.value);
                }}
              >
                <option value={false}>ทั้งหมด</option>
                <option value={"THB"}>บาท (ไทย)</option>
                <option value={"LAK"}>กีบ (ลาว) </option>
              </select>
            </div>
          </div>
          <div className="gap-2">
            <p className="font-medium text-xs">โปรโมชั่นโค้ด</p>
            <div>
              <select
                className="border-1 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedUsePromoCode}
                onChange={(e) => {
                  setSelectedUsePromoCode(e.target.value);
                }}
              >
                <option value={""}>ทั้งหมด</option>
                <option value={"true"}>ใช้โปรโมชั่นโค้ด</option>
                <option value={"false"}>ไม่ใช้โปรโมชั่นโค้ด</option>
              </select>
            </div>
          </div>
          <button
            disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={() => {
              getOrders();
            }}
          >
            <MdPersonSearch className="text-white" />
            ค้นหา
          </button>
          <button
            disabled={!allOrders.length}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
            onClick={() => {
              handleDownload();
            }}
          >
            ดาวโหลด
          </button>
        </div>
      </div>
      {/* Summary Stats */}
      {allOrders.length > 0 && (
        <div className="grid grid-cols-4 gap-4 mt-4">
          {/* QR Summary */}
          <div className="bg-white rounded-lg shadow-md p-4 border-l-4 border-blue-500">
            <p className="text-sm font-medium text-gray-600">ชำระด้วย QR</p>
            <p className="text-2xl font-bold text-blue-600 mt-2">
              {allOrders.filter((o) => o.paymentChannel === "qr").length}
            </p>
            <p className="text-xs text-gray-500 mt-1">คำสั่งซื้อ</p>
            <p className="text-lg font-semibold text-blue-600 mt-2">
              {allOrders
                .filter((o) => o.paymentChannel === "qr")
                .reduce((sum, o) => sum + getOrderPrice(o), 0)
                .toLocaleString()}
            </p>
            <p className="text-xs text-gray-500">{paidCurrency === "LAK" ? "กีบ" : "บาท"}</p>
          </div>

          {/* Bank Summary */}
          <div className="bg-white rounded-lg shadow-md p-4 border-l-4 border-green-500">
            <p className="text-sm font-medium text-gray-600">ชำระด้วย Bank</p>
            <p className="text-2xl font-bold text-green-600 mt-2">
              {allOrders.filter((o) => o.paymentChannel === "bank").length}
            </p>
            <p className="text-xs text-gray-500 mt-1">คำสั่งซื้อ</p>
            <p className="text-lg font-semibold text-green-600 mt-2">
              {allOrders
                .filter((o) => o.paymentChannel === "bank")
                .reduce((sum, o) => sum + getOrderPrice(o), 0)
                .toLocaleString()}
            </p>
            <p className="text-xs text-gray-500">{paidCurrency === "LAK" ? "กีบ" : "บาท"}</p>
          </div>

          {/* No Count Summary */}
          <div className="bg-white rounded-lg shadow-md p-4 border-l-4 border-yellow-500">
            <p className="text-sm font-medium text-gray-600">ไม่คิดเงิน</p>
            <p className="text-2xl font-bold text-yellow-600 mt-2">
              {allOrders.filter((o) => !o.paymentChannel).length}
            </p>
            <p className="text-xs text-gray-500 mt-1">คำสั่งซื้อ</p>
            <p className="text-lg font-semibold text-yellow-600 mt-2">
              {allOrders
                .filter((o) => !o.paymentChannel)
                .reduce((sum, o) => sum + getOrderPrice(o), 0)
                .toLocaleString()}
            </p>
            <p className="text-xs text-gray-500">{paidCurrency === "LAK" ? "กีบ" : "บาท"}</p>
          </div>

          {/* Total Summary */}
          <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg shadow-md p-4 border-l-4 border-blue-900">
            <p className="text-sm font-medium text-green">รวมทั้งหมด</p>
            <p className="text-2xl font-bold text-green mt-2">
              {allOrders.length}
            </p>
            <p className="text-xs text-blue-100 mt-1">คำสั่งซื้อ</p>
            <p className="text-lg font-semibold text-green mt-2">
              {allOrders
                .reduce((sum, o) => sum + getOrderPrice(o), 0)
                .toLocaleString()}
            </p>
            <p className="text-xs text-blue-100">{paidCurrency === "LAK" ? "กีบ" : "บาท"}</p>
          </div>
        </div>
      )}

      {/* admins */}
      {displayedOrders.length > 0 && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">คำสั่งซื้อทั้งหมด</p>{" "}
            <p className="text-xs font-semibold text-[#969797]">
              {displayedOrders.length} / {allOrders.length} คำสั่งซื้อ
            </p>
          </div>
          <div
            className="overflow-y-auto"
            style={{ height: "600px" }}
            onScroll={(e) => {
              const { scrollTop, scrollHeight, clientHeight } = e.target;
              if (scrollHeight - scrollTop <= clientHeight + 100) {
                handleLoadMore();
              }
            }}
          >
            <Table className="w-full">
              <TableHeader className={`bg-[#f2f3f5] sticky top-0 z-10`}>
                <TableRow>
                  <TableHead className="">ลำดับที่</TableHead>
                  <TableHead className="">เลขที่ใบกำกับภาษี</TableHead>
                  <TableHead className="">เวลาสร้างคำสั่งซื้อ</TableHead>
                  <TableHead className="">อนุมัติเมื่อ</TableHead>
                  <TableHead className="">รหัสคำสั่งซื้อ</TableHead>
                  <TableHead className="">ช่องทางการสั่งซื้อ</TableHead>
                  <TableHead className={"text-right"}>รหัสผู้ใช้</TableHead>
                  <TableHead>ชื่อ-นามสกุล</TableHead>

                  <TableHead>เบอร์โทรศัพท์</TableHead>
                  <TableHead className={"text-center"}>จำนวนสลาก</TableHead>
                  <TableHead className={"text-right"}>ส่วนลด</TableHead>
                  <TableHead className={"text-right"}>ค่าสลาก</TableHead>
                  <TableHead className={"text-right"}>ค่าบริการ</TableHead>
                  <TableHead className={"text-right"}>มูลค่าก่อนภาษี</TableHead>
                  <TableHead className={"text-right"}>ภาษี 7%</TableHead>
                  <TableHead className={"text-right"}>ราคารวม</TableHead>
                  <TableHead className="">ช่องทางการชำระ</TableHead>
                  <TableHead className="">สลิป</TableHead>
                  <TableHead className={"text-right"}>สถานะ</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody>
                {displayedOrders.map((order, index) => {
                  return (
                    <TableRow key={order.shortId}>
                      <TableCell className="font-semibold font-mono tabular-nums text-center">
                        {index + 1}
                      </TableCell>
                      <TableCell className="font-semibold font-mono tabular-nums text-center">
                        {order.taxNo || "-"}
                      </TableCell>
                      <TableCell className={`font-medium`}>
                        {new Date(order.createdAt).toLocaleDateString("th-TH", {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",

                        })}{" "}
                        น.
                      </TableCell>
                      <TableCell className={`font-medium`}>
                        {new Date(order.approvedAt).toLocaleTimeString(
                          "th-TH",
                          {

                            hour: "numeric",
                            minute: "numeric",
                          },
                        )}{" "}
                        น.
                      </TableCell>
                      <TableCell className="font-semibold font-mono tabular-nums text-center">
                        {order.shortId}
                      </TableCell>
                      <TableCell>
                        {order.deliverChannel === "online"
                          ? "1. ฝากไว้กับวันดี"
                          : order.deliverChannel === "mail"
                            ? "2. ส่งไปรษณีย์"
                            : "3. มารับเอง 80 บาท"}
                      </TableCell>
                      <TableCell
                        className={`font-semibold text-right font-mono tabular-nums`}
                      >
                        {order.userId}
                      </TableCell>
                      <TableCell className="font-medium">
                        {order.firstName + " " + order.lastName}
                      </TableCell>
                      <TableCell className="font-medium">
                        {order.phone}
                      </TableCell>
                      <TableCell className="text-center font-mono tabular-nums">
                        {order.size}
                      </TableCell>
                      <TableCell className="text-center font-mono tabular-nums">
                        {order.coupon
                          ? `${order.coupon?.coupon?.name} #${order.coupon.shortId} `
                          : "-"}
                        {order.isUsePromoCode && `${order.promoCode} (${order.promoDiscount})`}
                      </TableCell>

                      <TableCell className="font-semibold text-right font-mono tabular-nums">
                        {order.status === statuses.CANCEL
                          ? "-"
                          : order.totalPrice > 0
                            ? (order.size * 80).toLocaleString()
                            : 0}
                      </TableCell>
                      <TableCell className="font-semibold text-right font-mono tabular-nums">
                        {order.status === statuses.CANCEL
                          ? "-"
                          : order.totalPrice > 0
                            ? Math.max(
                              0,
                              order.totalPrice - order.size * 80,
                            ).toLocaleString()
                            : 0}
                      </TableCell>
                      <TableCell className="font-semibold text-right font-mono tabular-nums">
                        {order.status === statuses.CANCEL
                          ? "-"
                          : (
                            Math.max(0, order.totalPrice - order.size * 80) *
                            (100 / 107)
                          )
                            .toFixed(2)
                            .toLocaleString()}
                      </TableCell>
                      <TableCell className="font-semibold text-right font-mono tabular-nums">
                        {order.status === statuses.CANCEL
                          ? "-"
                          : Math.max(
                            0,
                            order.totalPrice -
                            order.size * 80 -
                            (order.totalPrice - order.size * 80) * (100 / 107),
                          )
                            .toFixed(2)
                            .toLocaleString()}
                      </TableCell>
                      <TableCell className="font-semibold text-right font-mono tabular-nums">
                        {order.status === statuses.CANCEL
                          ? "-"
                          : paidCurrency === "LAK" || order.paidCurrency === "LAK"
                            ? `${(order.totalPrice_lak || order.totalPrice)?.toLocaleString()} (กีบ)`
                            : order.totalPrice?.toLocaleString()}
                      </TableCell>
                      <TableCell className="font-semibold text-right font-mono tabular-nums">
                        {order.paymentChannel || "-"}
                      </TableCell>
                      <TableCell className="font-semibold text-right font-mono tabular-nums">
                        {order.paymentChannel === "qr" ? (
                          "qr"
                        ) : order.slips ? (
                          <img
                            onClick={() => window.open(order.slips, "_blank")}
                            src={order.slips}
                            alt="slip"
                          />
                        ) : (
                          <p className="text-failed font-semibold">xxxxx</p>
                        )}
                      </TableCell>
                      <TableCell className="">
                        <p
                          className={`${order.status === statuses.APPROVE
                            ? "text-[rgb(59,176,101)]"
                            : order.status === statuses.PAID
                              ? "text-[#4DA1A9]"
                              : order.status === statuses.PENDING
                                ? "text-[#FAB12F]"
                                : "text-[#c15b78]"
                            } text-right font-semibold`}
                        >
                          {constant.statusesTranslate[order.status]}
                        </p>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
          {displayedOrders.length < allOrders.length && (
            <div className="p-3 text-center text-sm text-gray-500">
              Scroll to load more... ({displayedOrders.length} /{" "}
              {allOrders.length})
            </div>
          )}
        </div>
      )}
    </div>
  );
};
